import styled, { css } from 'styled-components';

import { Flex, VFlex } from '@/components/base';
import { DASHBOARD_ROW_MAX_HEIGHT } from '@/features/Dashboard/types/constants';
import { radius } from '@/styles/sizes';

type CardStyleProps = {
  width: string;
  isDragging: boolean;
  isTextCard?: boolean;
};

const StyledDashboardCardWrapper = styled(Flex).attrs({
  f: 1,
})<CardStyleProps>`
  opacity: ${({ isDragging }) => (isDragging ? 0.3 : 1)};
  min-height: 100px;
  max-height: ${DASHBOARD_ROW_MAX_HEIGHT}px;
  position: relative;
  padding: 0 12px;
  width: ${({ width }) => width};
  ${({ isTextCard }) =>
    isTextCard &&
    css`
      min-height: 20px;
    `}
`;

const DashboardCardHeader = styled(Flex)`
  width: 100%;
  background-color: ${(props) => props.theme.colors.gray250};
  padding: 24px;
  border-radius: ${radius.token['3xl']}px;
  height: 88px;
`;

const StyledDashboardCard = styled(VFlex)`
  flex: 1;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: ${radius.token['3xl']}px;
  overflow: hidden;
  border: 1px solid ${(props) => props.theme.colors.gray400};
  width: 100%;
  transition: all 0.2s;
  .drag-area-handler {
    transition: all 0.2s;
    opacity: 0;
  }
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.primary100};
    .drag-area-handler {
      opacity: 1;
    }
  }
  &.focus {
    border: 1px solid ${(props) => props.theme.colors.primary100};
  }
`;

const StyledDashboardTextCard = styled(VFlex)`
  flex: 1;
  border-radius: ${radius.token['3xl']}px;
  border: 1px solid transparent;
  width: 100%;
  transition: all 0.2s;
  .drag-area-handler {
    transition: all 0.2s;
    opacity: 0;
  }
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.primary100};
    .drag-area-handler {
      opacity: 1;
    }
  }
`;

const StyledDragArea = styled.div`
  position: absolute;
  top: 14px;
  left: -4px;
  cursor: move;
  padding: 24px;
  z-index: 10;
`;

const ChartWrapper = styled.div`
  padding: 24px;
  flex: 1;
  overflow: auto;
`;

const DashboardCardStyles = {
  ChartWrapper,
  StyledDragArea,
  StyledDashboardCard,
  StyledDashboardCardWrapper,
  DashboardCardHeader,
  StyledDashboardTextCard,
};

export default DashboardCardStyles;
